/**
 * Small shared date/time formatting helpers with defensive guards.
 *
 * Timestamps reconstructed from pointer rows can be empty (`''`) for legacy
 * rows, and `new Date('').toLocaleString()` renders the literal string
 * "Invalid Date". These helpers return a fallback (an em dash by default) for
 * missing or unparseable input instead.
 */

/** Fallback rendered for a missing or unparseable timestamp. */
export const EMPTY_DATE = '—';

/**
 * Formats an ISO timestamp as a local date + time. Returns `fallback` (an em
 * dash by default) when the value is missing or does not parse to a real date.
 */
export function formatDateTime(
  iso: string | undefined | null,
  fallback: string = EMPTY_DATE,
): string {
  if (!iso) return fallback;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return fallback;
  return d.toLocaleString();
}
